import React from "react";

export default function PortfolioPage() {
  return <h2>PortfolioPage</h2>;
}
